<script>
	import { onMount } from "svelte";
	import Coin from './Coin.svelte';
	import Stats from './Stats.svelte';
	import ReloadingBar from './ReloadingBar.svelte';

	let prices = {};
	let reloadingValue;
	let reloadingPeriod = 60; // reloading every minute

	onMount(async () => {

		setInterval(() => {
			reloadingValue--;
		}, 1000);

		while(true){
			console.log("loading");
			getUsdtPrice('btc');
			getUsdtPrice('xrp');
			getUsdtPrice('eth');
			reloadingValue = reloadingPeriod;
			await sleep((reloadingPeriod+1)*1000);
		}
	})

	function sleep(ms) {
	  return new Promise(resolve => setTimeout(resolve, ms));
	}

	function getUsdtPrice(coin){
		fetch('https://api.binance.com/api/v3/avgPrice?symbol='+coin.toUpperCase()+'USDT')
		.then(r => r.json())
		.then(data => {
			let p = parseFloat(data.price);
			prices[coin] = p;
		});

		fetch('https://api.binance.com/api/v3/ticker/24hr?symbol='+coin.toUpperCase()+'USDT')
		.then(r => r.json())
		.then(data => {
			let p = parseFloat(data.priceChangePercent);
			prices[coin+"_evo"] = p.toFixed(2);
		});
	}

</script>

<main>

	<ReloadingBar 
		value={reloadingValue} 
		max={reloadingPeriod} 
	/>

	<Stats 
		prices={prices} 
	/>

	<Coin 
		code="btc" 
		price={prices.btc}
		evo={prices.btc_evo}
		graph="https://s3.coinmarketcap.com/generated/sparklines/web/7d/usd/1.png" 
	/>
	<Coin 
		code="xrp"
		price={prices.xrp} 
		evo={prices.xrp_evo}
		graph="https://s3.coinmarketcap.com/generated/sparklines/web/7d/usd/52.png" 
	/>
	<Coin 
		code="eth" 
		price={prices.eth}
		evo={prices.eth_evo}
		graph="https://s3.coinmarketcap.com/generated/sparklines/web/7d/usd/1027.png" 
	/>

</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
	}
</style>
